export const formatParticipationRate = (rate) => {
  const number = parseFloat(rate, 10).toFixed(1);
  return `${number}%`;
};
